import { GlDropdownItem } from '../../../../../../../node_modules/@gitlab/ui/src/index.js?vue3';
export default {
    name: 'DropdownFooter',
    components: {
        GlDropdownItem
    },
    inject: [
        'allowLabelCreate',
        'labelsManagePath'
    ],
    props: {
        footerCreateLabelTitle: {
            type: String,
            required: true
        },
        footerManageLabelTitle: {
            type: String,
            required: false,
            default: ''
        }
    },
    emits: [
        'toggle-dropdown-contents-create-view'
    ],
    computed: {
        showManageLabelsItem () {
            return this.footerManageLabelTitle && this.labelsManagePath;
        }
    }
};
